// extracted by mini-css-extract-plugin
export default {"nav":"MainNavigation_nav__OPDyB"};